export default "__VITE_ASSET__CMuvbNy4__"